module.exports = __webpack_public_path__ + "img/icon-medical-mask-menu-covid.7075696d.svg";